/* tslint:disable */

/**
 */
export class EquipCharact {
    ALPHA_FRONT?: number;
    ID_EQUIPCHARAC?: number;
    X_POSITION?: number;
    TEMP_REGUL?: number;
    ALPHA_TOP?: number;
    ALPHA_BOTTOM?: number;
    ALPHA_LEFT?: number;
    ALPHA_RIGHT?: number;
    ID_EQUIP?: number;
    ALPHA_REAR?: number;
    TEMP_TOP?: number;
    TEMP_BOTTOM?: number;
    TEMP_LEFT?: number;
    TEMP_RIGHT?: number;
    TEMP_FRONT?: number;
    TEMP_REAR?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/equip-charact.ts